import { GetSelfAppCategoryTimeSeriesQuery } from '../../../../src/interface/queries/app-category-metrics/get-self-app-category-time-series-summary.query';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetSelfAppCategoryTimeSeriesRequestDto } from '../../../../src/interface/dtos/app-category-metrics/get-self-app-category-time-series.request.dto';
import { GetSelfAppCategoryTimeSeriesResponseDto } from '../../../../src/interface/dtos/app-category-metrics/get-self-app-category-time-series.response.dto';
import { SelfAppCategoryTimeSeriesEntityMapper } from '../../../../src/infrastructure/mappers/app-category-metrics/self-app-category-time-series.entity.mapper';

export class GetSelfAppCategoryTimeSeriesController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetSelfAppCategoryTimeSeriesQuery,
    protected readonly mapper: SelfAppCategoryTimeSeriesEntityMapper
  ) {}

  async get(
    props: GetSelfAppCategoryTimeSeriesRequestDto
  ): Promise<GetSelfAppCategoryTimeSeriesResponseDto> {
    try {
      const result = await this.query.execute(props);
      return result.map((r) => this.mapper.toResponse(r));
    } catch (error) {
      throw new Error(
        `GetSelfAppCategoryTimeSeriesController.get encountered an error ${error}`
      );
    }
  }
}
